<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="isMobile() && podeAlterarIncluir" icon v-on="on" v-bind="attrs"
        ><v-icon size="28" color="error">mdi-delete-outline</v-icon></v-btn
      >
      <v-btn v-else-if="podeAlterarIncluir" rounded small dark color="error" v-on="on" v-bind="attrs" 
        ><v-icon class="mr-2" size="16">mdi-delete-outline</v-icon> Remover do
        plano</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="green lighten-4 font-weight-bold"
        >Remover dependente</v-card-title
      >
      <v-card-text class="pt-5 subtitle-1">
        Confirma a retirada do dependente <b>{{ dependente.nome }}</b> do plano?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" rounded @click="removerDependente()" :loading="removendo"
          >Sim, remover dependente</v-btn
        >
        <v-btn text rounded @click="dialog = false">Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from 'vuex';
export default {
  props: {
    dependente: Object,
  },
  computed: mapState("planoSaude",["podeAlterarIncluir"]),
  data: () => ({
    dialog: false,
    removendo: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    async removerDependente() {
      this.removendo = true;
      await axios
        .post("/colaborador/plano-saude/remover-dependente", JSON.stringify({
          id: this.dependente.codigo  
        }))
        .then((res) => {
          if (res.data.success) {
            this.$router.go();
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.removendo = false;
    },
  },
};
</script>

<style>
</style>